import { createConfiguration } from "@hyper-fetch/core";

import type { ApiRoutesSdk } from "@inginuiti/backend";

import { client } from "@/api/client";

export const organizationsConfiguration = createConfiguration<ApiRoutesSdk>()({
  // Switching organizations swaps the tenant behind every request, so any response
  // cached under the previous org is stale. Wipe the whole cache on a successful
  // switch so no org-scoped data leaks across organizations.
  "organizations.$organizationId.switch.$post": (request) => {
    request.$hooks.onResponse(({ response }) => {
      if (response.status === 200) {
        client.cache.invalidate(/.*/);
      }
    });

    return request;
  },
});
